import { AlertTriangle } from "lucide-react";
import { ddmmyyyy, inr } from "../../lib/format";

export const OverdueAlert = ({ overdue, onOpen }) => {
  if (!overdue?.length) return null;
  return (
    <div className="rise space-y-2 rounded-[14px] border border-destructive/40 bg-destructive/5 p-4" data-testid="overdue-alert">
      <p className="flex items-center gap-2 font-heading font-bold text-destructive">
        <AlertTriangle size={18} /> {overdue.length} PO{overdue.length === 1 ? "" : "s"} past expected delivery
      </p>
      <div className="divide-y divide-destructive/15">
        {overdue.map((o) => (
          <button key={o.id} type="button" onClick={() => onOpen(o.id)} className="flex w-full items-center justify-between gap-3 py-2 text-left"
            data-testid={`overdue-item-${o.po_no}`}>
            <span className="min-w-0">
              <span className="mono text-sm font-bold">{o.po_no}</span>
              <span className="block truncate text-xs text-muted-foreground">{o.vendor_name} · due {ddmmyyyy(o.expected_delivery)} · {inr(o.total)}</span>
            </span>
            <span className="chip shrink-0 border-destructive/40 text-destructive">{o.days_late} day{o.days_late === 1 ? "" : "s"} late</span>
          </button>
        ))}
      </div>
    </div>
  );
};
